import React, { useState } from "react";
import TaxTypeTable from "./tcs-tds-table";
import InnerLayout from "../../../../layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import search from "../../../../../assets/icons/searchIcon.svg";
import TabsComponent from "../../../../helper-components/tabs-component";
import TcsTdsTable from "./tcs-tds-table";
import {
  tcsTaxCreateAction,
  tcsTaxDeleteAction,
  tcsTaxImportAction,
  tcsTaxListAction,
  tdsTaxCreateAction,
  tdsTaxDeleteAction,
  tdsTaxImportAction,
  tdsTaxListAction,
} from "../../../../../redux/actions/settings-action";
import { downloadAllTemplates } from "../../../../helper-components/helper-function";
import DownloadIcon from "../../../../../assets/icons/download-icon";
import useCsvUpload from "../../../../helper-components/upload-csv-custom-hook";
import LoadingButtonSpinner from "../../../../helper-components/loading-button-spinner";
import excelImg from "../../../../../assets/icons/excel.png";
import successToast from "../../../../helper-components/success-toast";
import { Search } from "lucide-react";

const TcsTdsSetup = () => {
  const [reloadData, setReloadData] = useState(false);
  const [currentTab, setCurrentTab] = useState("TCS setup");
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const tcsTemplateArray = [
    {
      documentType: "TCS-TEMPLATE",
      expectedHeaders: ["tcs_name", "tcs_percentage", "tcs_type"],
    },
  ];
  const tdsTemplateArray = [
    {
      documentType: "TDS-TEMPLATE",
      expectedHeaders: ["tds_name", "tds_percentage", "tds_type"],
    },
  ];
  const tcsTdsTemplate =
    currentTab === "TCS setup" ? tcsTemplateArray : tdsTemplateArray;

  const actionType =
    currentTab === "TCS setup" ? tcsTaxImportAction : tdsTaxImportAction;

  const onSuccess = (data) => {
    setReloadData(!reloadData);
    successToast(data?.data?.message);
  };
  const onError = (data) => {};
  const { handleFileUpload, loading } = useCsvUpload(
    actionType,
    tcsTdsTemplate?.[0]?.expectedHeaders
  );

  return (
    <InnerLayout
      list={true}
      title="Settings"
      module="tax-setup"
      // permissionFn={permissionFn}
    >
      <div className="mx-6 h-full">
        {/* <div className="flex justify-between py-2 h-[4rem]">
          <div className=" pb-4 flex items-center gap-2 text-sm">
            <button
              className="flex items-center gap-2"
              onClick={() => {
                navigate("/settings");
              }}
            >
              <ChevronLeftIcon className="h-5 w-5 inline-block" />
              Settings /
            </button>
            <span className="cursor-pointer">{" " + "TCS TDS Setup"}</span>
          </div>
          <div className="flex items-center gap-3 pr-3">
            <div
              style={{ minWidth: "18rem", height: "2.5rem" }}
              className={`input_border flex items-center rounded-md w-10`}
            >
              <span className="px-2">
                {" "}
                <img width={"16px"} src={search} alt="search icon" />
              </span>
              <input
                placeholder={`Search here`}
                className=" table_search_input w-full rounded-md text-xs placeholder:text-xs"
                type="text"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                }}
              />
              <span
                className="text-sm mx-3 cursor-pointer text-primary"
                onClick={() => setSearchValue("")}
              >
                Clear
              </span>
            </div>
            <div>
              <input
                type="file"
                accept=".csv"
                onChange={(e) => handleFileUpload(e, onSuccess, onError)} // Pass onSuccess and onError functions
                className="hidden"
                id="csv-upload"
              />
              <label htmlFor="csv-upload">
                <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                  <img width={20} height={30} src={excelImg} alt="excel-icon" />
                  {loading ? (
                    <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                  ) : (
                    <span>Import</span>
                  )}
                </div>
              </label>
            </div>
            <button
              type="button"
              onClick={() => {
                downloadAllTemplates(tcsTdsTemplate);
              }}
              className="border-027A48 border-2 rounded-md px-2 py-2"
            >
              <DownloadIcon fill="var(--success-color)" />
            </button>
          </div>
        </div> */}

        <div className="flex justify-between items-center">
          <div className=" flex items-center gap-2 text-sml ">
            <button
              className="flex items-center gap-2"
              onClick={() => {
                navigate("/settings");
              }}
            >
              <ChevronLeftIcon className="h-5 w-5 inline-block " />
              Data Setup Settings /
            </button>
            <span className="cursor-pointer">
              {" " + "TCS, TDS Setup"}
            </span>
          </div>
          <div className="flex items-center gap-3 pr-3">
            <div
              style={{ minWidth: "18rem", height: "2.5rem" }}
              className={`border border-[var(--search-input-border)] flex  justify-between items-center rounded-md  w-10 `}
            >
              <input
                // ref={searchRef}
                placeholder={`Search (/)`}
                className=" table_search_input px-3 py-2 !border-none !outline-none !ring-0 text-[length:var(--search-label-font-size)] font-[var(--search-place-font-weight)]"
                type="text"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                }}
              />
              <span className="px-2">
                {" "}
                {<Search size="16" color="#9CA3AF" />}
              </span>
            </div>
            <div className=" flex flex-row gap-3">
              <div>
                <input
                  type="file"
                  accept=".csv"
                  onChange={(e) => handleFileUpload(e, onSuccess, onError)} // Pass onSuccess and onError functions
                  className="hidden"
                  id="csv-upload"
                />
                <label htmlFor="csv-upload">
                  <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                    <img
                      width={20}
                      height={30}
                      src={excelImg}
                      alt="excel-icon"
                    />
                    {loading ? (
                      <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                    ) : (
                      <span>Import</span>
                    )}
                  </div>
                </label>
              </div>
              <button
                type="button"
                onClick={() => {
                  downloadAllTemplates(tcsTdsTemplate);
                }}
                className="border-027A48 border-2 rounded-md px-2 py-1"
              >
                <DownloadIcon fill="var(--success-color)" />
              </button>
            </div>
          </div>
        </div>
        <TabsComponent
          handleClickfn={(item) => {
            setCurrentTab(item);
          }}
          itemTabs={itemTabs}
          setCurrentTab={setCurrentTab}
          currentTab={currentTab}
        />
        <div
          style={{
            height: "calc(100% - 8rem)",
          }}
        >
          <TcsTdsTable
            setReloadData={setReloadData}
            reloadData={reloadData}
            currentTab={currentTab}
            newLine={
              currentTab === "TCS setup"
                ? {
                    tcs_name: "",
                    tcs_percentage: 0,
                    tcs_type: "",
                  }
                : {
                    tds_name: "",
                    tds_percentage: 0,
                    tds_type: "",
                  }
            }
            createAction={
              currentTab === "TCS setup"
                ? tcsTaxCreateAction
                : tdsTaxCreateAction
            }
            listAction={
              currentTab === "TCS setup" ? tcsTaxListAction : tdsTaxListAction
            }
            deleteAction={
              currentTab === "TCS setup"
                ? tcsTaxDeleteAction
                : tdsTaxDeleteAction
            }
            searchValue={searchValue}
          />
        </div>
      </div>
    </InnerLayout>
  );
};

export default TcsTdsSetup;

const itemTabs = ["TCS setup", "TDS setup"];
